(function () {
  const popup = document.getElementById('czExitPopup');
  if (!popup) return;

  const STORAGE_KEYS = {
    dismissed: 'cz_winter10_exit_dismissed_until',
    shownSession: 'cz_winter10_exit_shown_session',
    accepted: 'cz_winter10_offer_accepted',
    addToCart: 'cz_exit_popup_added_to_cart',
    checkoutStarted: 'cz_exit_popup_checkout_started'
  };

  const config = {
    enabled: popup.dataset.enabled === 'true',
    delaySeconds: parseInt(popup.dataset.delaySeconds || '35', 10),
    hideForDays: parseInt(popup.dataset.hideForDays || '7', 10),
    offerCode: popup.dataset.offerCode || 'Winter10',
    title: popup.dataset.title || 'قبل ما تمشي 👀',
    text: popup.dataset.text || 'خدي 10% خصم على طلبك دلوقتي.',
    buttonText: popup.dataset.buttonText || 'انسخي الكود',
    closeText: popup.dataset.closeText || 'كمّلي من غير الخصم'
  };

  function pushEvent(name, extra) {
    const payload = Object.assign({
      offer_code: config.offerCode,
      offer_version: 'winter10_v2',
      recovery_stage: 'pre_atc'
    }, extra || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('cazameeza:' + name, payload);
      }
    } catch (e) {
      console.warn('Shopify analytics.publish failed', e);
    }
  }

  function markAddToCart() {
    sessionStorage.setItem(STORAGE_KEYS.addToCart, 'true');
  }

  function markCheckoutStarted() {
    sessionStorage.setItem(STORAGE_KEYS.checkoutStarted, 'true');
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action') || '').toLowerCase();

    if (action.includes('/cart/add')) {
      markAddToCart();
      pushEvent('cz_exit_popup_add_to_cart_detected');
    }

    if (action.includes('/checkout')) {
      markCheckoutStarted();
      pushEvent('cz_exit_popup_checkout_started_detected');
    }
  });

  if (!config.enabled) return;

  const titleEl = popup.querySelector('#czExitPopupTitle');
  const textEl = popup.querySelector('.cz-exit-popup__text');
  const codeEl = popup.querySelector('#czExitPopupCode');
  const copyBtn = popup.querySelector('#czExitPopupCopyBtn');
  const mainCta = popup.querySelector('#czExitPopupMainCta');
  const secondaryBtn = popup.querySelector('.cz-exit-popup__secondary');

  if (titleEl) titleEl.textContent = config.title;
  if (textEl) textEl.textContent = config.text;
  if (codeEl) codeEl.textContent = config.offerCode;
  if (copyBtn) copyBtn.textContent = config.buttonText;
  if (secondaryBtn) secondaryBtn.textContent = config.closeText;

  const path = window.location.pathname;
  const isProductPage = path.indexOf('/products/') === 0;
  const isCollectionPage = path.indexOf('/collections/') === 0;
  const isShoppingPage = isProductPage || isCollectionPage;
  if (!isShoppingPage) return;

  const now = Date.now();
  const dismissedUntil = parseInt(localStorage.getItem(STORAGE_KEYS.dismissed) || '0', 10);
  const shownSession = sessionStorage.getItem(STORAGE_KEYS.shownSession) === 'true';
  const accepted = localStorage.getItem(STORAGE_KEYS.accepted) === 'true';
  if (dismissedUntil > now || shownSession || accepted) return;

  let pagesViewed = parseInt(sessionStorage.getItem('cz_pages_viewed') || '0', 10) + 1;
  sessionStorage.setItem('cz_pages_viewed', String(pagesViewed));

  let popupShown = false;
  let popupOpening = false;
  let inactivityTimer = null;
  let hiddenAt = null;
  const startedAt = Date.now();

  async function getCart() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (e) {
      return null;
    }
  }

  function cartHasDiscount(cart) {
    if (!cart) return false;
    const cartLevel = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications.length
      : 0;
    return Number(cart.total_discount || 0) > 0 || cartLevel > 0;
  }

  async function canShowOffer() {
    if (localStorage.getItem(STORAGE_KEYS.accepted) === 'true') return false;
    if (sessionStorage.getItem(STORAGE_KEYS.addToCart) === 'true') return false;
    if (sessionStorage.getItem(STORAGE_KEYS.checkoutStarted) === 'true') return false;

    const cart = await getCart();
    if (!cart) return true;
    if (Number(cart.item_count || 0) > 0) return false;
    if (cartHasDiscount(cart)) return false;
    return true;
  }

  async function openPopup(triggerType) {
    if (popupShown || popupOpening) return;
    popupOpening = true;

    const eligible = await canShowOffer();
    popupOpening = false;
    if (!eligible || popupShown) return;

    popupShown = true;
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cz-popup-lock');
    document.body.classList.add('cz-popup-lock');
    sessionStorage.setItem(STORAGE_KEYS.shownSession, 'true');

    pushEvent('cz_exit_popup_shown', {
      trigger_type: triggerType,
      pages_viewed: pagesViewed,
      page_type: isProductPage ? 'product' : 'collection'
    });
  }

  function closePopup(reason) {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cz-popup-lock');
    document.body.classList.remove('cz-popup-lock');

    const hideUntil = Date.now() + (config.hideForDays * 24 * 60 * 60 * 1000);
    localStorage.setItem(STORAGE_KEYS.dismissed, String(hideUntil));
    pushEvent('cz_exit_popup_closed', { reason: reason || 'manual' });
  }

  document.addEventListener('click', function (e) {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const addToCartButton = target.closest('[name="add"], .product-form__submit, .ajax-add-to-cart, .add-to-cart');
    if (addToCartButton) {
      markAddToCart();
      pushEvent('cz_exit_popup_add_to_cart_detected');
      if (popupShown) closePopup('add_to_cart');
    }

    const checkoutButton = target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], .cart__checkout-button');
    if (checkoutButton) {
      markCheckoutStarted();
      pushEvent('cz_exit_popup_checkout_started_detected');
    }

    const closeTrigger = target.closest('[data-close-popup]');
    if (closeTrigger) closePopup('dismiss');
  });

  if (copyBtn) {
    copyBtn.addEventListener('click', async function () {
      try {
        await navigator.clipboard.writeText(config.offerCode);
        copyBtn.textContent = 'تم النسخ ✓';
        pushEvent('cz_exit_popup_coupon_copied');
      } catch (e) {
        pushEvent('cz_exit_popup_coupon_copy_failed');
      }
    });
  }

  if (mainCta) {
    mainCta.addEventListener('click', function (e) {
      e.preventDefault();
      localStorage.setItem(STORAGE_KEYS.accepted, 'true');
      pushEvent('cz_exit_popup_cta_clicked', { action: 'apply_discount' });

      const redirect = window.location.pathname + window.location.search;
      window.location.assign(
        '/discount/' + encodeURIComponent(config.offerCode) + '?redirect=' + encodeURIComponent(redirect)
      );
    });
  }

  function startInactivityTimer() {
    if (!isProductPage || popupShown) return;
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(function () {
      openPopup('inactivity');
    }, config.delaySeconds * 1000);
  }

  ['mousemove', 'scroll', 'keydown', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, startInactivityTimer, { passive: true });
  });
  startInactivityTimer();

  document.addEventListener('mouseout', function (e) {
    if (window.innerWidth < 992) return;
    if ((Date.now() - startedAt) < 12000) return;
    if (e.clientY <= 0) openPopup('exit_intent');
  });

  window.addEventListener('scroll', function () {
    if (window.innerWidth >= 992 || popupShown) return;
    if ((Date.now() - startedAt) < 25000) return;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const percent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

    if (percent > 70) {
      clearTimeout(window.czWinter10MobileExitDelay);
      window.czWinter10MobileExitDelay = setTimeout(function () {
        openPopup('mobile_scroll_intent');
      }, 1200);
    }
  }, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      hiddenAt = Date.now();
      return;
    }

    if (hiddenAt && (Date.now() - hiddenAt) >= 25000 && (Date.now() - startedAt) >= 20000) {
      openPopup('tab_return');
    }
    hiddenAt = null;
  });
})();
